import type { SeedOverwriteMode, SeedResult } from '@cli-types/next-adapter/commands.js'
import { parseSeedError } from './parse-seed-error.js'
import { runSeedScript } from './run-seed-script.js'

export async function runSeed(
  cwd: string,
  adminDir: string,
  authBasePath: string,
  email: string,
  password: string,
  overwriteMode?: SeedOverwriteMode
): Promise<SeedResult> {
  const result = await runSeedScript(cwd, adminDir, authBasePath, {
    SEED_EMAIL: email,
    SEED_PASSWORD: password,
    SEED_NAME: 'Admin',
    ...(overwriteMode ? { SEED_OVERWRITE_MODE: overwriteMode } : {})
  })

  if (result.timeout) {
    return { success: false, error: 'Seed timed out after 30 seconds' }
  }

  if (result.spawnError) {
    return { success: false, error: parseSeedError(result.stdout, result.spawnError) }
  }

  if (result.code === 0) {
    return { success: true, error: null }
  }

  if (result.code === 2) {
    const name = result.stdout.match(/EXISTING_USER:(.+)/)?.[1]?.trim()
    return { success: false, error: null, existingUser: name ?? email }
  }

  return { success: false, error: parseSeedError(result.stdout, result.stderr) }
}
